export const CHANGE_BASKET_ENTRY_TOTAL_PRICE = 'CHANGE_BASKET_ENTRY_TOTAL_PRICE';

export const changeBasketEntryTotalPrice = (payload: { basketEntryId: string, totalPrice: number }) => ({
    type: CHANGE_BASKET_ENTRY_TOTAL_PRICE,
    payload,
})